// Mock data for Gurkhas Cleaning Services

export const companyInfo = {
  name: "Gurkhas Cleaning Services",
  phone: "0452 029 732",
  phoneRaw: "0452029732",
  email: "Gurkhascleaning9672@gmail.com",
  address: {
    street: "33b O'Grady Dr",
    suburb: "Para Hills 5096",
    state: "SA, Australia"
  },
  tagline: "Cleaning with Honor, Service with Pride",
  subtitle: "Professional cleaning services delivered with dedication and excellence",
  copyright: "© 2026 Gurkhas Cleaning Services. All rights reserved.",
  logo: "https://i.ibb.co/GQLynRJK/logo-top-final.jpg",
  heroLogo: "https://i.ibb.co/9Hkcg2pz/logo.jpg"
};

export const navigation = [
  { name: "Home", href: "/" },
  { name: "Services", href: "/services" },
  { name: "Get Quote", href: "/quotes" },
  { name: "FAQs", href: "/faqs" },
  { name: "Careers", href: "/employment" },
  { name: "Contact", href: "/contact" }
];

export const aboutContent = {
  heading: "Why Choose Gurkhas Cleaning Services?",
  paragraphs: [
    "At Gurkhas Cleaning Services, we bring the same discipline, dedication, and honor that defines our heritage to every cleaning job we undertake.",
    "Our professionally trained team delivers exceptional results using eco-friendly products and industry-leading techniques.",
    "We believe in getting it right the first time, every time - delivering quality service with pride."
  ]
};

export const services = [
  {
    id: 1,
    name: "Commercial Cleaning",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&h=400&fit=crop",
    description: "Professional cleaning for offices, retail spaces, and commercial buildings.",
    icon: "Building2"
  },
  {
    id: 2,
    name: "End of Lease",
    image: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=600&h=400&fit=crop",
    description: "Thorough bond cleaning to help you get your full deposit back.",
    icon: "Key"
  },
  {
    id: 3,
    name: "Office Cleaning",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=600&h=400&fit=crop",
    description: "Keep your workplace spotless and professional every day.",
    icon: "Briefcase"
  },
  {
    id: 4,
    name: "Window Cleaning",
    image: "https://images.unsplash.com/photo-1563453392212-326f5e854473?w=600&h=400&fit=crop",
    description: "Crystal clear windows for homes and businesses.",
    icon: "Sparkles"
  },
  {
    id: 5,
    name: "Carpet Cleaning",
    image: "https://images.unsplash.com/photo-1558317374-067fb5f30001?w=600&h=400&fit=crop",
    description: "Deep carpet cleaning to remove stains and refresh your floors.",
    icon: "Layers"
  },
  {
    id: 6,
    name: "Residential Cleaning",
    image: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=600&h=400&fit=crop",
    description: "Regular home cleaning services tailored to your needs.",
    icon: "Home"
  }
];

export const features = [
  {
    title: "Trusted & Reliable",
    description: "Fully insured and background-checked professionals you can trust."
  },
  {
    title: "Eco-Friendly Products",
    description: "We use environmentally safe cleaning products for your health."
  },
  {
    title: "Flexible Scheduling",
    description: "Book at times that work for you, including weekends."
  },
  {
    title: "100% Satisfaction",
    description: "We're not happy until you're completely satisfied."
  }
];

export const footerLinks = [
  { name: "Contact", href: "/contact" },
  { name: "Privacy Policy", href: "/privacy" },
  { name: "Terms of Service", href: "/terms" }
];
